export default "__VITE_ASSET__92334e8c__"